import { useTranslator } from "components/Translator"
import { Text } from "components/Text"
import { Tag } from "components/Tag"
import cx from "classnames"
import { Price, formatPrice } from "components/Price"
import { Image } from "components/Image"

export const PlanPresentation = ({ plan, color }) => {
  const translator = useTranslator()
  const [priceEmbed] = plan.prices

  const productsTotalAmount =
    plan.products?.reduce((acc, product) => {
      const [priceEmbed] = product.prices

      return acc + priceEmbed.price.amount
    }, 0) ?? 0

  const mainPrice = priceEmbed.discountedPrice ?? priceEmbed.price
  const mainPriceAmount = mainPrice.amount + productsTotalAmount

  const originalPrice = priceEmbed.discountedPrice ? priceEmbed.price : null
  const originalPriceAmount = originalPrice
    ? originalPrice.amount + productsTotalAmount
    : null

  return (
    <div className="space-y-4">
      <div className="text-center">
        <Text variant="subtitle2">{plan.name}</Text>
      </div>
      {plan.monthObligation ? (
        plan.imageFile ? (
          <Image
            imageFile={plan.imageFile}
            size="w400"
            alt=""
            className="w-full h-full object-contain object-center"
          />
        ) : (
          <div className="flex justify-center">
            <Tag
              color={color === "primary" ? "notice" : "warning"}
              label={translator.trans(
                "club.plan.index.monthObligation",
                { nbMonths: plan.monthObligation },
                "pages",
              )}
            />
          </div>
        )
      ) : null}
      <div
        className={cx("text-center space-y-2", {
          "text-secondary-dark": color === "secondary",
          "text-primary-dark": color === "primary",
        })}
      >
        {originalPrice ? (
          <div className="line-through">
            <Text variant="headline6">
              <Price
                amount={
                  plan.monthFrequency > 0
                    ? originalPriceAmount / plan.monthFrequency
                    : originalPriceAmount
                }
                currency={mainPrice.currency.enum_value}
                additionalUnit={
                  plan.monthFrequency > 0
                    ? translator.trans(
                        "club.plan.index.perMonth",
                        null,
                        "pages",
                      )
                    : undefined
                }
              />
            </Text>
          </div>
        ) : null}
        <Text variant="headline2">
          {mainPriceAmount === 0 ? (
            translator.trans("club.plan.index.free", null, "pages")
          ) : (
            <Price
              amount={
                plan.monthFrequency > 0
                  ? mainPriceAmount / plan.monthFrequency
                  : mainPriceAmount
              }
              currency={mainPrice.currency.enum_value}
              additionalUnit={
                plan.monthFrequency > 0
                  ? translator.trans("club.plan.index.perMonth", null, "pages")
                  : undefined
              }
            />
          )}
        </Text>
      </div>
      {plan.monthFrequency > 1 ? (
        <div className="text-center">
          <Text variant="caption">
            {translator.trans(
              "club.plan.index.singlePayment",
              {
                price: formatPrice({
                  amount: mainPriceAmount,
                  currency: mainPrice.currency.enum_value,
                  locale: translator.locale,
                }),
              },
              "pages",
            )}
          </Text>
        </div>
      ) : null}
    </div>
  )
}
